import appConfig from "app.config";
import createHttpRequest from "utils/createHttpRequest";

const impressApi = createHttpRequest(appConfig.impressUrl);

impressApi.setAuthorization(`Bearer ${appConfig.impressAccessToken}`);

export default impressApi;
